import { DEVICES } from '@constants/global'
import { COLORS } from '@styles/colors'
import { text2XL } from '@styles/fonts'
import styled from 'styled-components'

export const EducationItem = styled.div`
  color: ${COLORS.navi};
  border-bottom: 1px solid #e2e4e5;
  padding: 12px 0;
`

export const EducationTitle = styled.h2`
  ${text2XL};
  color: ${COLORS.suburbHeading};
  letter-spacing: 1.6px;
  margin-bottom: 20px;

  @media ${DEVICES.mobile} {
    text-align: center;
  }
`
